import { render, staticRenderFns } from "./VerifyRegistration.vue?vue&type=template&id=3e6fd087"
import script from "./VerifyRegistration.vue?vue&type=script&lang=ts"
export * from "./VerifyRegistration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports